
import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calculator, Brain, FileText, Activity } from "lucide-react";

export function CalculatorSelection({ gender, onSelect, onBack }) {
  return (
    <motion.div
      className="max-w-2xl mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center gap-4 mb-8">
        <Button
          onClick={onBack}
          variant="ghost"
          className="text-[#ff3366] hover:text-[#ff3366]/80"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>
        <h2 className="text-xl font-bold text-[#ff3366]">
          Selecione o Tipo de Análise
        </h2>
      </div>

      <div className="grid gap-6">
        <motion.div
          whileHover={{ scale: 1.02 }}
          className="rounded-lg bg-[#1a1a2e]/50 p-6 shadow-lg backdrop-blur-sm border border-[#ff3366]/20"
        >
          <h3 className="text-lg font-semibold text-[#ff3366] mb-2">
            Calculadora Básica
          </h3>
          <p className="text-white/80 mb-4">
            {gender === "Masculino" 
              ? "Análise dos principais hormônios do eixo gonadal masculino"
              : "Análise dos principais hormônios do eixo gonadal feminino"}
          </p>
          <Button
            onClick={() => onSelect("basic")}
            className="w-full bg-[#ff3366] hover:bg-[#ff3366]/80"
          >
            <Calculator className="h-4 w-4 mr-2" />
            Iniciar Análise Básica
          </Button>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.02 }}
          className="rounded-lg bg-[#1a1a2e]/50 p-6 shadow-lg backdrop-blur-sm border border-[#ff3366]/20"
        >
          <h3 className="text-lg font-semibold text-[#ff3366] mb-2">
            Calculadora Avançada
          </h3>
          <p className="text-white/80 mb-4">
            {gender === "Masculino"
              ? "Análise completa incluindo hormônios secundários, metabólicos e marcadores específicos masculinos"
              : "Análise completa incluindo hormônios secundários, metabólicos e marcadores específicos femininos"}
          </p>
          <Button
            onClick={() => onSelect("advanced")}
            className="w-full bg-[#ff3366] hover:bg-[#ff3366]/80"
          >
            <Activity className="h-4 w-4 mr-2" />
            Iniciar Análise Avançada
          </Button>
        </motion.div>

        {gender === "Masculino" ? (
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="rounded-lg bg-[#1a1a2e]/50 p-6 shadow-lg backdrop-blur-sm border border-[#ff3366]/20"
          >
            <h3 className="text-lg font-semibold text-[#ff3366] mb-2">
              Questionário de Sintomas
            </h3>
            <p className="text-white/80 mb-4">
              Avaliação detalhada de sintomas de hipogonadismo e saúde masculina
            </p>
            <Button
              onClick={() => onSelect("symptoms")}
              className="w-full bg-[#ff3366] hover:bg-[#ff3366]/80"
            >
              <Brain className="h-4 w-4 mr-2" />
              Iniciar Questionário
            </Button>
          </motion.div>
        ) : (
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="rounded-lg bg-[#1a1a2e]/50 p-6 shadow-lg backdrop-blur-sm border border-[#ff3366]/20"
          >
            <h3 className="text-lg font-semibold text-[#ff3366] mb-2">
              Análise de Climatério
            </h3>
            <p className="text-white/80 mb-4">
              Avaliação específica para fase de climatério/menopausa com análise de sintomas
            </p>
            <Button
              onClick={() => onSelect("climacteric")}
              className="w-full bg-[#ff3366] hover:bg-[#ff3366]/80"
            >
              <FileText className="h-4 w-4 mr-2" />
              Iniciar Análise
            </Button>
          </motion.div>
        )}
      </div>
    </motion.div>
  );
}
